let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8N2iJ")).then(() => parcelRequire('73ds9'));